import { render, staticRenderFns } from "./StrokeTopLeftRightIcon.vue?vue&type=template&id=8faaeb9c&"
import script from "./StrokeTopLeftRightIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeTopLeftRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports